export const capitalize = (text = '') =>
    text.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());